module.exports = {
  SAVED_STATE_KEY: "savedStates"
};



// WEBPACK FOOTER //
// ./src/js/constants/UserSettings.js